const PARTNER_STORAGE_KEY = 'bondPartner';

/**
 * Returns the current partner from URL or sessionStorage.
 * Syncs URL partner to sessionStorage when present.
 */
export function getPartner(): string | null {
  const fromUrl = new URLSearchParams(window.location.search).get('partner');
  const fromStorage = sessionStorage.getItem(PARTNER_STORAGE_KEY);
  const partner = fromUrl ?? fromStorage;
  if (partner) {
    sessionStorage.setItem(PARTNER_STORAGE_KEY, partner);
  }
  return partner;
}

/**
 * Clears the stored partner from sessionStorage and redirects to current path without partner.
 */
export function clearPartner(): void {
  sessionStorage.removeItem(PARTNER_STORAGE_KEY);
  const url = new URL(window.location.href);
  url.searchParams.delete('partner');
  window.location.href = url.toString();
}

/**
 * Returns the given path with the partner query param appended if it exists.
 * Reads partner from URL first, then sessionStorage (persists across navigation).
 */
export function getPathWithPartner(path: string): string {
  const partner = getPartner();
  if (partner) {
    sessionStorage.setItem(PARTNER_STORAGE_KEY, partner);
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}partner=${encodeURIComponent(partner)}`;
  }
  return path;
}
